import React from "react";
import { useTranslation } from "react-i18next";
import SectionHeading from "./SectionHeading";
import PolaroidGallery from "./PolaroidGallery";
import { history } from "../../data/roadMapData";

// Narrative of the institution's journey followed by the photo wall.
// `history.paragraphs` is an i18n array, so a language can add or drop a
// paragraph without touching this component.
const HistorySection = () => {
  const { t } = useTranslation("roadmap");
  const paragraphs = t("history.paragraphs", {
    returnObjects: true,
    startYear: history.startYear,
    endYear: history.endYear,
    defaultValue: [],
  });

  return (
    <section className="rm-history" id="history">
      <div className="rm-container">
        <SectionHeading
          title={t("history.title")}
          subtitle={t("history.subtitle", {
            startYear: history.startYear,
            endYear: history.endYear,
          })}
        />

        <div className="rm-history__text">
          {(Array.isArray(paragraphs) ? paragraphs : []).map((paragraph, i) => (
            <p key={i}>{paragraph}</p>
          ))}
        </div>

        <PolaroidGallery />
      </div>
    </section>
  );
};

export default HistorySection;
